import React from 'react'
import _ from 'lodash'
import { Button, Col, FormInputSelect, Row } from 'camino-react'

import TextFieldSkeleton from 'Components/Skeletons/TextFieldSkeleton'

const ClientContactSelectField = ({
  clientContactsLoading,
  clientsUsersOptions,
  selectedClientsUserOption,
  setFieldErrorClasses,
  clientProperties,
  loadingClients,
  canCreateUsers,
  setFormState,
  handleClientContactSelectChange
}) => {
  if (clientContactsLoading) {
    return <TextFieldSkeleton width="full" loading />
  }

  const addContactButtonStyles = {
    display: 'flex',
    border: '1px solid #c0e2ff',
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
    height: '38px',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '23px',
    cursor: 'pointer'
  }

  if (_.some(clientsUsersOptions) || loadingClients) {
    return (
      <Row noGutters>
        <Col width={loadingClients ? 24 : 23}>
          <FormInputSelect
            placeholder="Select from the list..."
            style={{ borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}
            id="ticket_client_contact_id"
            options={clientsUsersOptions}
            isLoading={loadingClients}
            disabled={loadingClients}
            value={selectedClientsUserOption}
            className={setFieldErrorClasses('client_contact_id')}
            onValue={id => handleClientContactSelectChange(_.find(clientsUsersOptions, ['value', id]))}
          />
        </Col>

        {(!loadingClients && canCreateUsers) && (
          <Col width={1}>
            <i className='lnr lnr-plus' style={addContactButtonStyles} onClick={() => {
              setFormState('creatingContact', true)
              setFormState('creatingContactForClient', clientProperties.client_id)
            }} />
          </Col>
        )}
      </Row>
    )
  }
  return (
    <p>
      There are no users for this client.
      <Button type='link' onClick={() => {
        setFormState('creatingContact', true)
        setFormState('creatingContactForClient', clientProperties.client_id)
      }}>
        Add one here.
      </Button>
    </p>
  )
}

export default ClientContactSelectField
